__turbopack_context__.v({
  "border": "Section-module-scss-module__iebikW__border",
  "center": "Section-module-scss-module__iebikW__center",
  "container": "Section-module-scss-module__iebikW__container",
  "default": "Section-module-scss-module__iebikW__default",
  "gradient": "Section-module-scss-module__iebikW__gradient",
  "large": "Section-module-scss-module__iebikW__large",
  "medium": "Section-module-scss-module__iebikW__medium",
  "noPadding": "Section-module-scss-module__iebikW__noPadding",
  "right": "Section-module-scss-module__iebikW__right",
  "transparent": "Section-module-scss-module__iebikW__transparent",
  "wave": "Section-module-scss-module__iebikW__wave",
});
